import React from "react";
import { Smartphone, Download, ShieldCheck, Zap } from "lucide-react";
import { getEnv } from "../../../../../AppConfigs";
import { Icon } from "../../../../../components";
import styles from "./ChatHomepage.module.scss";

const ChatHomepage: React.FC = () => {
  return (
    <div className={styles.chatHomepage}>
      <div className={styles.content}>
        <div className={styles.topTag}>
          <Smartphone size={16} />
          <span>Ứng dụng di động</span>
        </div>

        <h1 className={styles.title}>Tải eOffice - VIAGS</h1>
        <p className={styles.subtitle}>Quét mã QR để tải ứng dụng và trải nghiệm làm việc mọi lúc, mọi nơi</p>

        <div className={styles.scanLabel}>
          <div className={styles.scanIconWrapper}>
            <Smartphone size={14} />
          </div>
          <span>Quét mã QR để tải xuống</span>
        </div>

        <div className={styles.cardsWrapper}>
          {/* iOS Card */}
          <div className={styles.card}>
            <img src="/assets/images/eOffice-VIAGS-ios.png" alt="iOS QR" className={styles.qrImage} />
            <a href={getEnv("REACT_APP_IOS_APP_URL")} target="_blank" rel="noreferrer" className={styles.storeLink}>
              <Icon.DownloadIOS />
            </a>
          </div>

          {/* Android Card */}
          <div className={styles.card}>
            <img src="/assets/images/eOffice-VIAGS-android.png" alt="Android QR" className={styles.qrImage} />
            <a href={getEnv("REACT_APP_ANDROID_APP_URL")} target="_blank" rel="noreferrer" className={styles.storeLink}>
              <Icon.DownloadAndroid />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatHomepage;
